import React from 'react';
import SealRow from 'components/SealRow';

const RecommendedSealList = ({ seals }) => {
  if (!seals.length) {
    return <div className="recommended-seals__empty">All seals unlocked</div>;
  }

  return (
    <ul className="recommended-seals__list">
      {seals.map((seal) => (
        <SealRow key={seal.key} sealKey={seal.key} name={seal.name} />
      ))}
    </ul>
  );
};

const RecommendedSeals = ({ seals }) => {
  if (!Array.isArray(seals)) {
    return null;
  }

  return (
    <div
      className={`recommended-seals${
        seals.length ? '' : ' recommended-seals--empty'
      }`}>
      <div className="recommended-seals__heading">
        Recommended Seals to Unlock
      </div>

      <RecommendedSealList seals={seals} />
    </div>
  );
};

export default RecommendedSeals;
